export const ADMIN_ROLE_REQUIRED_MESSAGE = 'Для входа нужны права администратора';

export class AdminRoleRequiredError extends Error {
    constructor() {
        super(ADMIN_ROLE_REQUIRED_MESSAGE);
        this.name = 'AdminRoleRequiredError';
    }
}

export const isAdminRoleRequiredError = (error: unknown): error is AdminRoleRequiredError => {
    return error instanceof AdminRoleRequiredError;
};
